import { Store } from 'react-stores';

export const searchWrapperStore = new Store({
    index: null,
    store: null
});
